import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import { Grid, Alert } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import logo from "../../assets/img/pibs_logo_2.png";

const useStyles = makeStyles({
  root: {
    borderRadius: 16,
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.5)",
  },
});

export default function CreatePassword() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [password, setPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [passwordMatchError, setPasswordMatchError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  console.log({ loading });

  const handleNewSubmit = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    e.preventDefault();
    if (value.trim() !== "" && value.length > 8 && value.length < 16) {
      setNewPasswordError(false);
    } else {
      setNewPasswordError(true);
    }
  };

  const handleConfirmSubmit = (e) => {
    const value = e.target.value;
    setPassword(value);
    e.preventDefault();

    // Check if password is not empty
    if (value.trim() !== "") {
      setPasswordError(false);

      // Check if passwords match (only if both passwords have values)
      if (newPassword && value) {
        if (newPassword === value) {
          setPasswordMatchError(false);
          setErrorMessage("");
        } else {
          setPasswordMatchError(true);
          setErrorMessage("Passwords do not match.");
        }
      }
    } else {
      setPasswordError(true);
      setPasswordMatchError(false);
    }
  };
  const handleProceed = () => {
    // Clear any previous error messages
    setErrorMessage("");

    // Validate all conditions before starting loading
    if (!newPassword || !password) {
      setErrorMessage("Please fill in both password fields.");
      return;
    }

    if (newPasswordError) {
      setErrorMessage("New password must be between 8-16 characters.");
      return;
    }

    if (newPassword !== password) {
      setPasswordMatchError(true);
      setErrorMessage("Passwords do not match.");
      return;
    }

    // All validations passed, start loading and make API call
    setLoading(true);

    try {
      const validationToken = sessionStorage.getItem("validationToken");
      const admissionNumber = sessionStorage.getItem("admissionNumber");
      api({
        url: "/auth/student/register",
        method: "POST",
        data: {
          validation_token: validationToken,
          admission_number: admissionNumber,
          password: password,
        },
      })
        .then((res) => {
          setLoading(false); // Stop loading on success
          console.log(res);
          if (res.status === 200) {
            console.log(res.data.data);
            navigate("/auth/login");
          }
        })
        .catch((err) => {
          setLoading(false); // Stop loading on error
          if (err.response && err.response.data && err.response.data.message) {
            setErrorMessage(err.response.data.message);
          } else {
            setErrorMessage("Failed to create password. Please try again.");
          }
          console.log(err.code);
          console.log(err.message);
        });
    } catch (error) {
      setLoading(false); // Stop loading on exception
      setErrorMessage("An unexpected error occurred. Please try again.");
      console.log(error);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center px-2 bg-gradient-to-b from-gray-100 to-gray-300">
      <Card
        className={classes.root}
        sx={{ minWidth: 300, maxWidth: 400 }}
        variant="outlined"
      >
        <CardMedia
          sx={{ height: 72, width: 72, margin: "auto" }}
          component="img"
          image={logo}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div" align="center">
            PIBS Student Portal Login
          </Typography>
          <Grid container rowGap={3} marginTop={3}>
            {errorMessage && (
              <Alert severity="error" sx={{ width: "100%" }}>
                {errorMessage}
              </Alert>
            )}
            <TextField
              required
              fullWidth
              label="New Password (8-16 characters)"
              type="password"
              value={newPassword}
              onChange={handleNewSubmit}
              size="small"
              error={newPasswordError}
              helperText={
                newPasswordError
                  ? "Password must be between 8-16 characters"
                  : ""
              }
            />
            <div style={{ width: "100%" }}>
              <TextField
                required
                fullWidth
                label="Confirm Password"
                type="password"
                value={password}
                onChange={handleConfirmSubmit}
                size="small"
                error={passwordError || passwordMatchError}
                helperText={
                  passwordMatchError
                    ? "Passwords do not match"
                    : passwordError
                    ? "Please confirm your password"
                    : "Please Set Your Login Password."
                }
              />
            </div>
          </Grid>
        </CardContent>
        <CardActions>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            rowGap={1}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <LoadingButton
                loading={loading}
                size="medium"
                variant="contained"
                onClick={handleProceed}
                loadingIndicator="..."
              >
                Proceed
              </LoadingButton>
            </div>
          </Grid>
        </CardActions>
      </Card>
    </div>
  );
}
